<div class="card">

  <div class="card-header ais-color d-flex flex-row justify-content-between"
       title="{{title}}"
       (click)="headerClick()">
    <div class="h6 title">{{title}}</div>
    <button i18n-title title="Ďalšie informácie, položky štúdia" mat-mini-fab color="warn" (click)="goToDetail()"><mat-icon>read_more</mat-icon></button>
  </div>

  <div class="card-body small" *ngIf="show">
    <app-zapisne-listy [studium]="data"></app-zapisne-listy>
    <app-zaverecne-prace [zaverecnePrace]="data.zaverecnePrace" [studium]="data"></app-zaverecne-prace>
    <app-statne-skusky [data]="data.statneSkusky" [studium]="data"></app-statne-skusky>
    <app-slavnosti [data]="data.slavnosti" [studium]="data"></app-slavnosti>
  </div>

</div>
